import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    home_eyebrow: 'Universe',
    home_subtitle: 'Choose the profile you want to explore',
    home_footer: '© 2026 Joaquin Montes',
    char_actor_sub: 'Film · Theatre · TV',
    char_dev_sub: 'Full Stack · Web · Apps',
    char_video_sub: 'Video · Motion · Color',
    char_coach_sub: 'Actors · Technique · Scene',
    char_bar_sub: 'Cocktails · Bar · Events',
    back: 'Back',
    contact_cta: 'Signal through the static',
    representation: 'Representation',
    actor_eyebrow: 'SAG-AFTRA Eligible · Actor',
    actor_tagline: 'Film · Television · Theatre · Voice Over',
    actor_height: 'Height',
    actor_height_val: `6'2"`,
    actor_yrs_pro: 'years telling stories',
    actor_dialects_label: 'dialects',
    actor_statement: '"The role of the artist is to ask questions, not answer them."',
    actor_film: 'Film',
    actor_tv: 'Television',
    actor_theatre: 'Theatre',
    actor_commercial: 'Commercial & Voice Over',
    actor_training: 'Training',
    actor_dialects: 'Dialects & Accents',
    actor_special_skills: 'Special Skills',
    actor_dialect_expert: 'Dialect',
    actor_dialect_expert_sub: 'Expert',
    actor_bfa_line1: 'Bachelor of Fine Arts — Acting',
    actor_bfa_line2: 'Univ. of Central Florida',
    actor_headshots: 'Headshots',
    actor_demo_reel: 'Reels',
    actor_nav_reel: 'Reel',
    actor_nav_resume: 'Résumé',
    admin_login_title: 'Admin',
    admin_email: 'Email',
    admin_password: 'Password',
    admin_login_btn: 'Sign In',
    admin_logging_in: 'Signing in…',
    admin_login_error: 'Invalid credentials',
    admin_logout: 'Sign Out',
    admin_carousel_title: 'Carousel Order',
    admin_drag_hint: 'Drag cards to reorder, then save.',
    admin_save_order: 'Save Order',
    admin_saving: 'Saving…',
    admin_saved: 'Saved',
    admin_save_error: 'Save Failed',
    admin_no_photos: 'No photos yet. Upload one below.',
    admin_delete: 'Delete',
    admin_delete_confirm: 'Delete this photo? This cannot be undone.',
    admin_delete_error: 'Delete failed. Please try again.',
    admin_upload_title: 'Upload New Photo',
    admin_choose_file: 'Choose a JPEG, PNG, or WebP file…',
    admin_upload_btn: 'Upload',
    admin_uploading: 'Uploading…',
    admin_upload_error: 'Upload failed. Please try again.',
    actor_skill_1: 'Firearms Training (Handguns & Semi-automatics)',
    actor_skill_2: 'Web / App Developer',
    actor_skill_3: 'Bartender',
    actor_skill_4: 'Poker Player',
    actor_skill_5: 'Competitive Gamer',
    actor_d_1: 'Mexican',
    actor_d_2: 'Colombian',
    actor_d_3: 'Argentinian',
    actor_d_4: 'Cuban',
    actor_d_5: 'Brazilian',
    actor_d_6: 'Peruvian',
    actor_d_7: 'Italian',
    actor_d_8: 'British',
    actor_d_9: 'Cockney',
    actor_d_10: 'Scottish',
    actor_d_11: 'Russian',
    actor_d_12: 'German',
    dev_eyebrow: '$ whoami',
    dev_bio: 'Focused on building tools and experiences that improve the quality of life of the people who use them.',
    dev_stack: '// tech stack',
    dev_projects: '// projects',
    vid_title1: 'Editing that',
    vid_title2: 'tells stories',
    vid_subtitle: 'Joaquin Montes — Video Editor',
    vid_services: 'Services',
    vid_formats: 'Formats',
    vid_software: 'Software',
    vid_s1_title: 'Video Editing',
    vid_s1_desc: 'Narrative editing, pacing and rhythm. From raw footage to final piece.',
    vid_s2_title: 'Color Grading',
    vid_s2_desc: 'Custom LUTs, correction and coherent image aesthetics.',
    vid_s3_title: 'Motion Graphics',
    vid_s3_desc: 'Titles, transitions and animations that elevate content.',
    vid_s4_title: 'Post-Production',
    vid_s4_desc: 'Full pipeline from ingest to delivery in all formats.',
    coach_eyebrow: 'Acting Coach',
    coach_title1: 'Transform your',
    coach_title2: 'instrument',
    coach_bio: 'With over a decade as a professional actor, Joaquin Montes guides actors at all levels of their career. An honest, rigorous and transformative work space.',
    coach_cta: 'Book a session',
    coach_programs: 'Programs',
    coach_quote: '"The bravest actor is not the most technical. It\'s the one who dares not to know."',
    coach_p1_title: 'Fundamentals of Acting', coach_p1_level: 'Beginner',
    coach_p1_desc: 'For actors just starting out. Foundations of organic work, presence and listening.',
    coach_p1_sessions: '8 sessions · Online/In person',
    coach_p2_title: 'Scene & Camera', coach_p2_level: 'Intermediate',
    coach_p2_desc: 'Technical work on camera. Self-tape, audition and character development.',
    coach_p2_sessions: '10 sessions · In person',
    coach_p3_title: 'Individual Coaching', coach_p3_level: 'All levels',
    coach_p3_desc: 'Audition prep, specific roles and acting career evolution.',
    coach_p3_sessions: 'Flexible · 1:1',
    pillar1: 'Presence', pillar1_desc: 'Being before doing',
    pillar2: 'Listening', pillar2_desc: 'The other as trigger',
    pillar3: 'Risk', pillar3_desc: 'Comfort kills truth',
    pillar4: 'Play', pillar4_desc: 'Creativity without censorship',
    bar_eyebrow: 'Craft Cocktails · Bar',
    bar_title1: 'The art of', bar_title2: 'the perfect', bar_title3: 'glass',
    bar_subtitle: 'Joaquin Montes · Bartender',
    bar_bio: 'Over 8 years behind the bar. Classic technique, seasonal ingredients and one philosophy: every drink tells a story.',
    bar_signature: 'Signature', bar_menu: 'Signature Selection',
    bar_services: 'Services',
    bar_years: 'years of experience', bar_recipes: 'signature recipes', bar_events: 'events served',
  },
  es: {
    home_eyebrow: 'Universo',
    home_subtitle: 'Elige el perfil que quieres explorar',
    home_footer: '© 2026 Joaquin Montes',
    char_actor_sub: 'Cine · Teatro · Series',
    char_dev_sub: 'Full Stack · Web · Apps',
    char_video_sub: 'Vídeo · Motion · Color',
    char_coach_sub: 'Actores · Técnica · Escena',
    char_bar_sub: 'Cocktails · Barra · Eventos',
    back: 'Volver',
    contact_cta: 'Señal a través del ruido',
    representation: 'Representación',
    actor_eyebrow: 'SAG-AFTRA Eligible · Actor',
    actor_tagline: 'Cine · Televisión · Teatro · Voice Over',
    actor_height: 'Altura',
    actor_height_val: '1.85 m',
    actor_yrs_pro: 'años contando historias',
    actor_dialects_label: 'dialectos',
    actor_statement: '"El papel del artista es hacer preguntas, no responderlas."',
    actor_film: 'Cine',
    actor_tv: 'Televisión',
    actor_theatre: 'Teatro',
    actor_commercial: 'Commercial & Voice Over',
    actor_training: 'Formación',
    actor_dialects: 'Dialectos & Acentos',
    actor_special_skills: 'Habilidades Especiales',
    actor_dialect_expert: 'Experto',
    actor_dialect_expert_sub: 'en Dialectos',
    actor_bfa_line1: 'Licenciatura en Bellas Artes — Actuación',
    actor_bfa_line2: 'Univ. de Florida Central',
    actor_headshots: 'Fotografías',
    actor_demo_reel: 'Reels',
    actor_nav_reel: 'Reel',
    actor_nav_resume: 'CV',
    admin_login_title: 'Admin',
    admin_email: 'Correo',
    admin_password: 'Contraseña',
    admin_login_btn: 'Iniciar Sesión',
    admin_logging_in: 'Iniciando…',
    admin_login_error: 'Credenciales incorrectas',
    admin_logout: 'Cerrar Sesión',
    admin_carousel_title: 'Orden del Carrusel',
    admin_drag_hint: 'Arrastra las tarjetas para reordenar y luego guarda.',
    admin_save_order: 'Guardar Orden',
    admin_saving: 'Guardando…',
    admin_saved: 'Guardado',
    admin_save_error: 'Error al Guardar',
    admin_no_photos: 'Sin fotos aún. Sube una abajo.',
    admin_delete: 'Eliminar',
    admin_delete_confirm: '¿Eliminar esta foto? Esta acción no se puede deshacer.',
    admin_delete_error: 'Error al eliminar. Inténtalo de nuevo.',
    admin_upload_title: 'Subir Nueva Foto',
    admin_choose_file: 'Elige un archivo JPEG, PNG o WebP…',
    admin_upload_btn: 'Subir',
    admin_uploading: 'Subiendo…',
    admin_upload_error: 'Error al subir. Inténtalo de nuevo.',
    actor_skill_1: 'Entrenamiento con Armas de Fuego (Pistolas y Semiautomáticas)',
    actor_skill_2: 'Desarrollador Web / App',
    actor_skill_3: 'Bartender',
    actor_skill_4: 'Jugador de Póker',
    actor_skill_5: 'Gamer Competitivo',
    actor_d_1: 'Mexicano',
    actor_d_2: 'Colombiano',
    actor_d_3: 'Argentino',
    actor_d_4: 'Cubano',
    actor_d_5: 'Brasileño',
    actor_d_6: 'Peruano',
    actor_d_7: 'Italiano',
    actor_d_8: 'Británico',
    actor_d_9: 'Cockney',
    actor_d_10: 'Escocés',
    actor_d_11: 'Ruso',
    actor_d_12: 'Alemán',
    dev_eyebrow: '$ whoami',
    dev_bio: 'Enfocado en crear herramientas y experiencias que mejoren la calidad de vida de las personas que las usen.',
    dev_stack: '// tech stack',
    dev_projects: '// proyectos',
    vid_title1: 'Edición que', vid_title2: 'cuenta historias',
    vid_subtitle: 'Joaquin Montes — Editor de Vídeo',
    vid_services: 'Servicios', vid_formats: 'Formatos', vid_software: 'Software',
    vid_s1_title: 'Edición de Vídeo',
    vid_s1_desc: 'Montaje narrativo, pacing y ritmo. Del bruto a la pieza final.',
    vid_s2_title: 'Color Grading',
    vid_s2_desc: 'LUTs personalizados, corrección y estética de imagen coherente.',
    vid_s3_title: 'Motion Graphics',
    vid_s3_desc: 'Títulos, transiciones y animaciones que elevan el contenido.',
    vid_s4_title: 'Post-Producción',
    vid_s4_desc: 'Flujo completo desde ingest hasta entrega en todos los formatos.',
    coach_eyebrow: 'Coaching Actoral',
    coach_title1: 'Transforma tu', coach_title2: 'instrumento',
    coach_bio: 'Con más de una década como actor profesional, Joaquin Montes acompaña a actores en todos los niveles de su carrera. Un espacio de trabajo honesto, riguroso y transformador.',
    coach_cta: 'Reserva una sesión',
    coach_programs: 'Programas',
    coach_quote: '"El actor más valiente no es el más técnico. Es el que se atreve a no saber."',
    coach_p1_title: 'Fundamentos de Interpretación', coach_p1_level: 'Iniciación',
    coach_p1_desc: 'Para actores que empiezan. Bases del trabajo orgánico, presencia y escucha.',
    coach_p1_sessions: '8 sesiones · Online/Presencial',
    coach_p2_title: 'Escena & Cámara', coach_p2_level: 'Intermedio',
    coach_p2_desc: 'Trabajo técnico ante cámara. Self-tape, audición y desarrollo de personaje.',
    coach_p2_sessions: '10 sesiones · Presencial',
    coach_p3_title: 'Coaching Individualizado', coach_p3_level: 'Todos los niveles',
    coach_p3_desc: 'Preparación de audiciones, roles específicos y evolución de carrera actoral.',
    coach_p3_sessions: 'Flexible · 1:1',
    pillar1: 'Presencia', pillar1_desc: 'Estar antes de hacer',
    pillar2: 'Escucha', pillar2_desc: 'El otro como detonante',
    pillar3: 'Riesgo', pillar3_desc: 'La comodidad mata la verdad',
    pillar4: 'Juego', pillar4_desc: 'Creatividad sin censura',
    bar_eyebrow: 'Craft Cocktails · Barra',
    bar_title1: 'El arte de', bar_title2: 'la copa', bar_title3: 'perfecta',
    bar_subtitle: 'Joaquin Montes · Bartender',
    bar_bio: 'Más de 8 años detrás de la barra. Técnica clásica, ingredientes de temporada y una filosofía: cada trago cuenta una historia.',
    bar_signature: 'Firma', bar_menu: 'Selección de Firma',
    bar_services: 'Servicios',
    bar_years: 'años de experiencia', bar_recipes: 'recetas de autor', bar_events: 'eventos servidos',
  },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('en');
  const t = (key) => translations[lang][key] || key;
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
